{
  "topMenu": {
    "dihTitle": "Centro de inteligencia de datos",
    "dihSubTitle": "Extrae valor de los datos de forma segura",
    "logout": "Cerrar sesión",
    "dihPortal": "Portal DIH",
    "cofinityDataspace": "Portal del espacio de datos",
    "portal": "Portal"
  },
  "userLogoutAlert": {
    "title": "¿Estás seguro de que deseas cerrar sesión?",
    "back": "Volver",
    "logout": "Cerrar sesión"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Inicio",
    "collapse": "Colapsar barra lateral",
    "help": "Ayuda",
    "prepare": "Gestión de modelos",
    "model": "Modelo de datos",
    "mapping": "Mapeo de datos",
    "converter": "Convertidor de datos",
    "provide": "Proveer",
    "publishData": "Publicar datos",
    "assets": "Activos",
    "policyPublicationTemplate": "Plantilla de publicación de políticas",
    "uploadHistory": "Historial de carga de activos",
    "consume": "Consumir",
    "searchDataOffers": "Buscar ofertas de datos",
    "negotiatedDataOffers": "Ofertas de datos negociadas",
    "downloadHistory": "Historial de descarga de activos",
    "govern": "Gobernar",
    "myPolicies": "Mis políticas",
    "createPolicies": "Crear políticas",
    "policyTemplate": "Plantillas de políticas",
    "manageAndConfig": "Configurar",
    "connections": "Gestionar conectores",
    "jobs": "Registros de procesos",
    "monitoring": "Monitorizar",
    "licences": "Licencias",
    "contractAgreements": "Acuerdos de contrato",
    "providedAgreements": "Acuerdos de contrato proporcionados",
    "incomingAgreements": "Ofertas de datos entrantes",
    "consumedAgreements": "Acuerdos de contrato consumidos",
    "consumeAutomation": "Automatización de consumo de políticas",
    "networkAnalytics": "Analítica de red",
    "otherLogs": "Otros registros",
    "digitalTwin": "Navegador de gemelos digitales",
    "messagesBrowserInbound": "Mensajes entrantes",
    "messagesBrowserOutbound": "Mensajes salientes",
    "applications": "Aplicaciones",
    "electronicControlUnit": "Unidad de Control Electrónico",
    "pcfExchange": "Intercambio PCF (Jupiter)",
    "pcfExchangeV9": "Intercambio PCF (Saturn)",
    "pcfRequests": "Solicitudes de datos PCF",
    "pcfExchangeHistory": "Historial de intercambio de datos PCF",
    "pcfExchangeV9History": "Historial de intercambio de datos PCF v9",
    "publicationTemplates": "Plantillas de publicación",
    "certificateManagement": "Gestión de certificados",
    "certificates": "Certificados",
    "connectors": "Mis conectores",
    "contractDefinitions": "Mis definiciones de contrato"
  },
  "versionModal": {
    "title": "Información general",
    "error": "No se pudieron obtener los detalles de la versión",
    "table": {
      "title": "Detalles del componente",
      "componentName": "Nombre del componente",
      "imageVersion": "Versión de la imagen",
      "chartVersion": "Versión de la lista"
    }
  },
  "dropdown": {
    "selectAll": "Seleccionar todo",
    "noOption": "No hay opciones disponibles",
    "noSuchOption": "No existe tal opción ...",
    "selectConnection": "Selecciona una conexión"
  },
  "certificateManagement": {
    "title": "Gestión de Certificados de Socios Comerciales",
    "description": "Bienvenido a la solución de intercambio de gestión de certificados de socios comerciales de extremo a extremo fácil de usar en Catena-X.",
    "howTo": {
      "description": "Descubre el catálogo de ofertas de datos de otras empresas miembros de Catena-X. Puedes buscar, seleccionar y suscribirte a una oferta de certificado. Puedes buscar ofertas de certificados usando el nombre de la empresa.",
      "doc": "¿Quieres saber más sobre cómo funciona la gestión de certificados de socios comerciales?"
    },
    "landingTiles": {
      "tile_1": {
        "title": "Certificado de publicación",
        "description": "Cree y comparta sus certificados de sitio en la red Catena-X."
      },
      "tile_2": {
        "title": "Descubrir y consumir certificados",
        "description": "Busque y descargue fácilmente certificados de sitios y empresas."
      },
      "tile_3": {
        "title": "Historial de publicación de certificados",
        "description": "Resumen de todos tus certificados proporcionados"
      },
      "tile_4": {
        "title": "Historial de certificados consumidos",
        "description": "Resumen de todos tus certificados consumidos"
      },
      "tile_5": {
        "title": "Solicitudes entrantes de certificados",
        "description": "Resumen de las solicitudes entrantes para compartir certificados"
      },
      "tile_6": {
        "title": "Estado de certificados salientes",
        "description": "Resumen de las acciones para compartir certificados"
      },
      "tile_7": {
        "title": "Solicitar certificados",
        "description": "Busque y descargue fácilmente certificados de sitios y empresas."
      }
    },
    "recentCertificateRequests": "Solicitudes recientes de datos de certificados entrantes",
    "learnMore": "Más información sobre la gestión de certificados",
    "requestCertificates": "Solicitar nuevos certificados",
    "pushCertificate": "Enviar certificado",
    "pushDescription": "El certificado existente se compartirá con el socio seleccionado a continuación. Tenga en cuenta que se aplicará el mismo conjunto de políticas que en la oferta original. Si desea cambiar las políticas, cree una nueva oferta de datos.",
    "pushSuccess": "¡Se ha iniciado el proceso de envío de certificados! El ID de trabajo es {id}",
    "receiverBpn": "Receptor BPN",
    "providerBpn": "BPN del proveedor",
    "locationBpns": "Sitio BPNA/BPNS",
    "certificateType": "Tipo de certificado",
    "requestSuccess": "¡Solicitud de certificado enviada correctamente!",
    "pushResult": "{successful} de {total} solicitudes {status} exitosas",
    "receiveConfirmTitle": "Reconocer recepción del certificado",
    "receiveConfirmDesc": "Al hacer clic en Sí, usted reconoce haber recibido el certificado compartido por el socio. El proveedor recibirá su confirmación. Luego, puede aceptar o rechazar el certificado.",
    "acceptedConfirmTitle": "Aceptar certificado",
    "acceptedConfirmDesc": "Al hacer clic en Sí, acepta que el certificado cumple con las expectativas. Puede descargar el certificado en PDF haciendo clic en el ícono de vista.",
    "rejectedConfirmTitle": "Rechazar certificado",
    "rejectedConfirmDesc": "Al hacer clic en Sí, usted rechaza el certificado entrante. El proveedor será notificado del rechazo y podrá compartirlo nuevamente o usted podrá solicitar uno nuevo.",
    "processStarted": "'{type}' ¡Proceso iniciado! El ID del trabajo es {id}",
    "certificateDetails": "Detalles del certificado",
    "availableCertificate": "Ubicación del certificado disponible",
    "updateSuccess": "¡Certificado actualizado con éxito!",
    "updateFailure": "¡Falló la actualización del certificado!",
    "wizard": {
      "selectCompanies": "Seleccionar empresas",
      "selectPolicies": "Seleccionar políticas"
    },
    "step1Description": "Seleccione una o más empresas con las que compartir el certificado. ",
    "step2Description": "Seleccione las políticas para compartir certificados. ",
    "noPoliciesFound": "No se encontraron pólizas para las empresas seleccionadas.",
    "policiesFound": "{count} políticas encontradas",
    "selectedPolicies": "{count} seleccionado",
    "policyName": "Nombre de la política",
    "bpn": "BPN",
    "policyType": "Tipo",
    "errorFetchingPolicies": "No se pudieron recuperar las políticas. ",
    "assetId": "ID de activo",
    "noPoliciesFoundInCatalog": "No se encontraron pólizas en el catálogo para las empresas seleccionadas.",
    "duplicateBpnError": "No puede seleccionar el mismo BPN dos veces.",
    "membershipValue": "Membresía",
    "contractReference": "Referencia del contrato",
    "noCompatibleOfferPush": "No se encontró ninguna oferta compatible con CCM-Push. Pida a sus socios comerciales seleccionados que publiquen una.",
    "noCompatibleOfferAvailable": "No se encontró ninguna oferta compatible con CCM-Available. Pida a sus socios comerciales seleccionados que publiquen una."
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Información básica del certificado",
        "issuer": "Información del emisor",
        "validity": "Período de validez",
        "trust": "Información de confianza",
        "validator": "Información del validador",
        "application": "Área de aplicación",
        "enclosedSites": "Sitios incluidos"
      },
      "fields": {
        "businessPartnerNumber": "Número de socio comercial",
        "registrationNumber": "Número de registro",
        "certificateType": "Tipo de certificado",
        "certificateVersion": "Versión del certificado",
        "issuerName": "Nombre del emisor",
        "issuerBpn": "BPN del emisor",
        "validFrom": "Válido desde",
        "validUntil": "Válido hasta",
        "trustLevel": "Nivel de confianza",
        "uploaderBpn": "BPN del cargador",
        "validatorBpn": "BPN del validador",
        "validatorName": "Nombre del validador",
        "areaOfApplication": "Área de aplicación",
        "siteBpn": "BPN del sitio",
        "siteAreaOfApplication": "Área de aplicación del sitio"
      },
      "tooltips": {
        "basicInfo": "Un certificado de socio comercial describe un certificado (por ejemplo ISO9001, IATF-16949) a través de un documento de certificado de un socio comercial Catena-X",
        "businessPartnerNumber": "El Número de Socio Comercial (BPN) de la entidad jurídica certificada (sobre la cual se emite el certificado).",
        "registrationNumber": "Número de registro del certificado según se define en el certificado",
        "certificateType": "Tipo de certificado según se define en el documento, los tipos válidos están registrados en el controlador de metadatos BPN",
        "certificateVersion": "Versión del certificado según se define en el documento, usualmente la versión específica de un estándar de certificación",
        "issuerName": "Nombre del emisor, es decir, la autoridad certificadora.",
        "issuerBpn": "El Número de Socio Comercial (BPN) del emisor.",
        "validFrom": "Fecha de validez desde, según se define en el certificado.",
        "validUntil": "Válido hasta la fecha definida en el certificado. Si el certificado nunca expira, el valor esperado es 9999-12-31",
        "trustLevel": "El nivel de confianza del certificado dado - none, low, high, trusted",
        "uploaderBpn": "El Número de Socio Comercial (BPN) del socio comercial que proporcionó originalmente los datos o documento del certificado.",
        "validatorBpn": "El Número de Socio Comercial (BPN) del proveedor de servicios de datos que validó el certificado dado",
        "validatorName": "El nombre opcional del proveedor de servicios de datos que validó el certificado dado",
        "areaOfApplication": "Detalles sobre qué áreas / tipos de aplicación para los cuales un certificado es válido para una empresa y/o sitio.",
        "siteBpn": "El Número de Socio Comercial (BPNS o BPNA) de un sitio incluido",
        "siteAreaOfApplication": "Detalles sobre qué áreas / tipos de aplicación para los cuales un certificado es válido para una empresa y/o sitio."
      }
    }
  },
  "common": {
    "start": "Comenzar",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "email": "Correo electrónico",
    "phoneNumber": "Número de teléfono",
    "contactPerson": "Persona de contacto",
    "welcome": "Bienvenido",
    "street": "Calle",
    "city": "Ciudad",
    "country": "País",
    "postCode": "Código postal",
    "number": "Número",
    "next": "Siguiente",
    "prev": "Atrás",
    "alreadyAccount": "¿Ya tienes una cuenta?",
    "login": "Iniciar sesión",
    "loginNow": "Inicia sesión ahora",
    "register": "Registrarse",
    "home": "Inicio",
    "submit": "Enviar",
    "attention": "Atención",
    "desc": "Descripción",
    "website": "Sitio web",
    "contact": "Contacto",
    "details": "Detalles",
    "plan": "Plan",
    "table": "Tabla",
    "grid": "Cuadrícula",
    "listView": "Vista de lista",
    "gridView": "Vista de cuadrícula",
    "firstPage": "A la primera página",
    "previousPage": "A la página anterior",
    "nextPage": "A la página siguiente",
    "lastPage": "A la última página",
    "paginationUnknownButton": "Tipo de botón de paginación desconocido",
    "download": "Descargar",
    "delete": "Eliminar",
    "edit": "Editar",
    "information": "Información",
    "organization": "Organización",
    "cancel": "Cancelar",
    "save": "Guardar",
    "upload": "Subir",
    "link": "Enlace",
    "view": "Ver",
    "search": "Buscar",
    "selectOption": "Selecciona una opción",
    "sortBy": "Ordenar por",
    "dataspace": "Espacio de datos",
    "select": "Seleccionar",
    "date": "Fecha",
    "title": "Título",
    "back": "Atrás",
    "startTyping": "Empieza a escribir",
    "useCases": "Casos de uso",
    "done": "Hecho",
    "enterValue": "Introduce un valor",
    "selectValue": "Selecciona un valor",
    "selectDate": "Selecciona una fecha",
    "selectYear": "Año selecto",
    "refresh": "Actualizar",
    "provided": "Proporcionados",
    "consumed": "Consumidos",
    "searchByName": "Buscar por nombre",
    "close": "Cerrar",
    "copyToClipboard": "¡Copiado al portapapeles!",
    "enterKeyName": "Introduce el nombre de la clave",
    "fileDownloadSuccess": "Archivo descargado con éxito",
    "fileDownloadError": "Error al descargar el archivo",
    "certificate": "Certificado",
    "manageConnections": "Gestionar conexiones",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "connectionDetails": "{type} Detalles de conexión",
    "hide": "Esconder",
    "unpublish": "Inútil",
    "clear": "Claro",
    "viewAll": "Ver todo",
    "apply": "Aplicar",
    "from": "De",
    "to": "A",
    "isRequired": "se requiere",
    "confirmationRequired": "Por favor confirme marcando la casilla",
    "send": "Enviar",
    "update": "Actualizar",
    "createSend": "Crear y enviar",
    "share": "Compartir",
    "recentRequests": "Solicitudes recientes",
    "severity": "Gravedad",
    "expectedResponseBy": "Respuesta esperada por",
    "active": "Activo",
    "viewDocs": "Ver documentación",
    "request": "Solicitar",
    "noData": "Sin datos",
    "autosaving": "Guardado automático",
    "connectIntegrate": "Connect & Integrate"
  },
  "genericError": "¡Oh, algo salió mal! Por favor, inténtalo de nuevo.",
  "validation": {
    "fieldRequired": "{field} es obligatorio.",
    "fieldNumeric": "El campo {field} solo puede contener números.",
    "fieldAlpha": "El campo {field} solo puede contener letras, _ y -.",
    "fieldAlphanumeric": "El campo {field} solo puede contener letras, números, _ y -.",
    "fieldNumericDash": "El campo {field} solo puede contener números y -.",
    "fieldHouseNumber": "El campo {field} solo puede contener números, letras y los caracteres - y /.",
    "fieldPhoneNumber": "El campo {field} solo puede contener números y -. Debe comenzar con + o 00.",
    "fieldAlphaDash": "El campo {field} solo puede contener letras y -.",
    "exceptHTMLTagBrackets": "El campo {field} no debe contener los siguientes caracteres: ^<>",
    "isMaxLength": "supera la longitud máxima de 10 caracteres.",
    "emailFormat": "El formato del correo electrónico es incorrecto",
    "fileSizeError": "El tamaño del archivo es mayor que {size} MB.",
    "csvFileSizeError": "Este archivo es demasiado grande. Puedes subir archivos de hasta {size} MB.",
    "csvFileExtensionError": "Solo se permiten archivos con extensión csv.",
    "csvFileIsEmptyError": "Este archivo está vacío. Debes subir al menos un archivo de {size} KB.",
    "csvFileFormatError": "El archivo no coincide con el formato esperado. Por favor, usa la plantilla proporcionada e inténtalo de nuevo.",
    "uploadFails": "la carga falló",
    "fileExtensionError": "La extensión del archivo no es adecuada",
    "fileIsMalwareInfectedError": "Este archivo parece contener malware. Por razones de seguridad, este archivo no puede ser subido. Por favor, revisa tu archivo nuevamente",
    "customValidation": "El {field} tiene un formato incorrecto.",
    "selectCountryFirst": "Por favor, selecciona primero el nombre del país",
    "validationPostCodeCaseDE": "El campo tiene un formato incorrecto. Debe contener 5 dígitos, por ejemplo, 53113",
    "validationAlphanumericCase": "El campo solo puede contener caracteres alfanuméricos, guiones y guiones bajos. El valor debe comenzar con un carácter alfanumérico.",
    "validationNumericDashCase": "El campo solo puede contener números y -.",
    "url": "Por favor, introduce una URL válida",
    "required": "Este campo es obligatorio",
    "password": {
      "passwordStrength": "Fortaleza de la contraseña",
      "weak": "Débil",
      "average": "Media",
      "strong": "Fuerte",
      "passwordValidationMoreChar": "{count} o más caracteres",
      "passwordUpperAndLowerChar": "Caracteres en mayúsculas y minúsculas",
      "passwordAtLeastNumber": "Al menos un número",
      "passwordAtLeastSpecialChar": "Al menos un carácter especial (excepto <>&\"`[])",
      "passwordDiffFromPrev": "Difiere de tus contraseñas anteriores"
    }
  },
  "footer": {
    "tagLine": "Impulsando un mayor rendimiento",
    "imprint": "Aviso legal",
    "imprintShort": "Aviso legal",
    "imprintLink": "https://dih.telekom.com/es/imprint",
    "contact": "Contacto",
    "contactLink": "https://dih.telekom.com/es/contacto",
    "termsAndConditions": "Términos y condiciones",
    "privacy": "Política de privacidad",
    "privacyShort": "Privacidad",
    "telekom": "T-Systems International GmbH. Todos los derechos reservados.",
    "telekomShort": "T-Systems Internacional GmbH",
    "note": "Telekom Data Intelligence Hub - Solo para clientes empresariales",
    "brandedNote": "Desarrollado por Telekom Data Intelligence Hub",
    "cookieSettings": "Configuración de cookies",
    "cookieSettingsShort": "Galletas",
    "life": "La vida es para compartir"
  },
  "cookieSettings": {
    "collapsedTitle": "Configuración de privacidad",
    "collapsedText": "Este sitio web utiliza cookies y tecnologías similares. Son pequeños archivos de texto que se almacenan y leen en tu ordenador. Al hacer clic en '{0}', aceptas el procesamiento, la creación de perfiles de usuario individuales en sitios web y socios, y la transferencia de tus datos a terceros, algunos de los cuales procesan tus datos en países fuera de la Unión Europea (GDPR Art. 49). Los detalles se pueden encontrar en la sección 2 de la {1}. Los datos se utilizan para análisis, retargeting y para mostrar contenido y publicidad personalizada en sitios de Telekom y de terceros. Más información, incluyendo información sobre el procesamiento de datos por parte de terceros y la posibilidad de revocación, se puede encontrar en la configuración y en nuestra información de privacidad. Aquí puedes {2} solo con las herramientas necesarias.",
    "extendedTitle": "Configuración de privacidad",
    "extendedText": "Para ofrecerte una experiencia web óptima, utilizamos cookies. Estas incluyen cookies para el funcionamiento y la optimización del sitio, así como para servicios como chat de texto o vídeo y para publicidad basada en tu comportamiento de uso en línea. Esto nos permite, por ejemplo, detectar si visitas nuestras páginas repetidamente desde el mismo dispositivo. Nos gustaría darte la opción de elegir qué cookies permites:",
    "policyLinkHref": "https://dih.telekom.com/es/política-de-privacidad",
    "policyLinkCookieHref": "https://dih.telekom.com/es/política-de-privacidad",
    "policyLinkTextShort": "información de privacidad",
    "policyLinkText": "Información de privacidad",
    "rejectLinkText": "continuar",
    "acceptButton": "Aceptar todo",
    "saveButton": "Guardar configuración",
    "settingsButton": "Cambiar configuración",
    "showMore": "Mostrar más",
    "showLess": "Mostrar menos",
    "categoryTitleEssential": "Cookies necesarias",
    "categoryTitleAnalytics": "Cookies analíticas",
    "categoryTitleMarketing": "Cookies de marketing",
    "categoryTitleThirdParty": "Servicios de otras empresas (proveedores independientes)",
    "categoryTextEssential": "Estas cookies son necesarias para que puedas navegar por los sitios web y utilizar funciones clave. Soportan funciones básicas, como el procesamiento de pedidos en la tienda online y el acceso a áreas seguras de la página web. También sirven para realizar un análisis anónimo de los patrones de usuario, que utilizamos para desarrollar y mejorar continuamente nuestras páginas web para ti.",
    "categoryTextAnalytics": "Estas cookies nos ayudan a mejorar nuestra comprensión del comportamiento del usuario. Las cookies de análisis permiten la recopilación de datos de uso e identificación por parte del proveedor original o de terceros en perfiles de uso seudónimos. Utilizamos cookies de análisis, por ejemplo, para determinar el número de visitantes individuales a una página web o servicio, recopilar datos estadísticos sobre el rendimiento de nuestros productos y analizar los patrones de uso e interacciones de los visitantes sobre la base de información anónima y seudónima. Esta información no puede ser rastreada hasta una persona.",
    "categoryTextMarketing": "Estas cookies y tecnologías similares se utilizan para permitir la visualización de contenido de marketing personalizado y, por lo tanto, relevante. Las cookies de marketing se utilizan para mostrar contenido publicitario interesante y para medir la efectividad de nuestras campañas. Esto ocurre no solo en los sitios web de Telekom, sino también en otros sitios de socios publicitarios (proveedores externos). Esto también se llama retargeting. Se utiliza para crear perfiles de contenido o anuncios seudónimos, colocar publicidad relevante en otros sitios web y obtener información sobre los grupos objetivo que han visto los anuncios y el contenido. Esta información no puede ser rastreada hasta una persona. Las herramientas de marketing y retargeting nos ayudan a mostrarte contenido publicitario que puede ser relevante para ti. Al suprimir las cookies de marketing, seguirás viendo la misma cantidad de publicidad, pero puede que sea menos relevante para ti.",
    "categoryTextThirdParty": "Los sitios web de Telekom incluyen enlaces a proveedores de servicios externos, que prestan sus servicios bajo su propia responsabilidad. Cuando visitas las páginas web de Telekom, las cookies o tecnologías similares registran datos y los envían a terceros, en parte para fines propios de Telekom. El alcance, propósito y base legal sobre la que se lleva a cabo el procesamiento posterior para los propios fines del tercero se pueden encontrar en la información de privacidad de datos del tercero. La información sobre los proveedores independientes se puede encontrar en la información de privacidad de datos."
  },
  "messages": {
    "noDataAvailable": "No hay datos disponibles",
    "noMatchFound": "No se encontró coincidencia",
    "maximumFileSize": "Tamaño máximo de archivo",
    "suitableFileFormats": "Formatos de archivo adecuados",
    "loading": "Cargando...",
    "dragDropText": "o arrástralo y suéltalo aquí",
    "noConnectors": "¡No se encontraron conectores!",
    "comingSoon": "Próximamente"
  },
  "pageNotFound": {
    "title": "¡Ups! Parece que la página que buscas aún no existe.",
    "subtitle": "Mientras tanto, consulta nuestros otros recursos, ¡pueden ser útiles para ti!"
  },
  "helpResources": {
    "needHelp": "¿Necesitas ayuda para encontrar el plan adecuado, más información o tienes preguntas técnicas?",
    "needHelpShorter": "¿Necesita más ayuda?",
    "developerDoc": "Documentación de la API",
    "developerDocDesc": "Obtenga la documentación de la API para la automatización del intercambio de datos",
    "example": "Ejemplo",
    "examples": "Guía del usuario",
    "tutorials": "Tutoriales",
    "exampleDescription": "Encuentra casos de uso y demostraciones relevantes para tu sector industrial",
    "FAQ": "Preguntas frecuentes",
    "FAQDescription": "Encuentra respuestas comunes desde facturación hasta privacidad",
    "browse": "Explorar",
    "demos": "Demostraciones",
    "demosDescription": "Encuentra casos de uso y demostraciones relevantes para tu sector industrial",
    "glossary": "Glosario",
    "glossaryDescription": "Encuentra los términos y definiciones relacionados con Data Intelligence Hub, IDSA, Catena-X, Gaia-X y más.",
    "glossaryDescriptionShorter": "Encuentre términos y definiciones de Catena-X, Gaia-X y más",
    "customerSupport": "Soporte al cliente",
    "customerSupportDesc": "¿No encontró lo que estaba buscando?",
    "contactUs": "Esta función no está disponible en su suscripción actual. Contáctenos para actualizar.",
    "contactUsBtn": "Contáctenos"
  },
  "basicInfo": {
    "title": "Información básica",
    "dataspace": "Espacio de datos",
    "bpn": "Número de socio comercial"
  },
  "feedbackCard": {
    "title": "¿Necesitas más ayuda?",
    "contactUs": "Contáctanos"
  },
  "error": {
    "pageNotFound": "Página no encontrada (404)",
    "somethingWrong": "¡Algo salió mal!",
    "propertyNotFound": "Propiedad no encontrada",
    "uniquePropertyName": "El nombre de la propiedad debe ser único",
    "dctTypeNotFound": "dct:type no encontrado"
  },
  "helpWidget": {
    "askSupport": "Solicitar soporte",
    "chatboxTitle": "Chat de ayuda",
    "chatboxSubtitle": "Soporte de Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Hola, bienvenido al canal de soporte de Telekom Data Intelligence Hub. Por favor, selecciona una opción a continuación."
    },
    "whatCanWeHelpWith": "¿En qué podemos ayudarte hoy?",
    "suggestedAnswers": {
      "knowledgeBase": "Base de conocimientos, documentación y preguntas frecuentes",
      "contactSupport": "Contactar soporte",
      "contactSales": "Contactar ventas"
    }
  },
  "pcfExchange": {
    "title": "Intercambio PCF",
    "description": "Bienvenido a la solución de intercambio de Product Carbon Footprint (PCF) de extremo a extremo fácil de usar en Catena-X.",
    "recentRequests": "Solicitudes recientes de datos PCF",
    "viewAllRequests": "Ver todas las solicitudes",
    "requestPcf": "Solicitar PCF",
    "termCheck": "Al enviar la solicitud, entiendo que el contrato se negociará sobre la oferta de datos según las políticas establecidas por el proveedor de datos.",
    "pcfSuccess": "¡PCF solicitado con éxito!",
    "landing": {
      "pcfTitle": "Crear oferta PCF",
      "pcfDesc": "Crea y comparte los datos PCF con participantes en la red Catena-X.",
      "discoverTitle": "Descubre y solicita datos PCF",
      "discoverDesc": "Busca fácilmente datos PCF en la red Catena-X o solicita los datos PCF a tus socios en pocos pasos.",
      "pcfReqTitle": "Solicitudes de datos PCF",
      "pcfReqDesc": "Gestiona eficientemente las solicitudes de datos PCF de tus socios en la red Catena-X.",
      "pcfCalcTitle": "Calculadora PCF",
      "pcfCalcDesc": "Calcula los valores PCF y conéctate a tus aplicaciones o escenarios de intercambio de datos PCF sin problemas.",
      "pcfHistoryTitle": "Historial de intercambio de datos PCF",
      "pcfHistoryDesc": "Obtén transparencia sobre tu historial de intercambio de datos PCF en la red Catena-X y tus socios.",
      "documentation": "Aprende sobre el intercambio de datos PCF",
      "howTo": {
        "description": "Comparte, descubre y gestiona las ofertas de datos de la huella de carbono del producto (PCF) dentro de Catena-X.",
        "doc": "¿Quieres saber más sobre Connect & Integrate? Enlace a la documentación: "
      }
    },
    "requests": {
      "pcfRequests": "Solicitudes de datos PCF",
      "reqDesc": "Utiliza el área para gestionar tus solicitudes de datos PCF de socios.",
      "productId": "ID de producto*",
      "bpn": "BPN*",
      "message": "Mensaje",
      "howTo": {
        "title": "¿Quieres saber más sobre cómo funciona la gestión de solicitudes de datos PCF?",
        "description": "Utiliza esta sección para aprobar o rechazar la solicitud de datos PCF de tus socios. Además, consulta los estados de los intercambios de datos PCF y obtén total transparencia en tu cadena de datos PCF.",
        "doc": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?"
      }
    },
    "responses": {
      "howTo": {
        "description": " Descubre el catálogo de ofertas de datos de otras empresas miembros de Catena-X. Puedes buscar, seleccionar y suscribirte a una oferta de datos. Puedes buscar ofertas de datos usando el nombre de la empresa o con el ID de pieza del fabricante o con una combinación de ambos."
      }
    },
    "view": {
      "title": "Ver detalles de PCF"
    }
  },
  "pcfExchangeV9": {
    "landing": {
      "pcfReqTitle": "PCF Provider",
      "pcfHistoryTitle": "PCF Consumer"
    },
    "incomingRequests": "Solicitudes PCF entrantes",
    "sentResponses": "Respuestas PCF enviadas",
    "sentRequests": "Solicitudes PCF enviadas",
    "incomingResponses": "Respuestas PCF entrantes",
    "requests": {
      "pcfRequests": "PCF Provider",
      "partIdDescription": "Proporcione el ID de pieza del fabricante o el ID de pieza del cliente. Al menos uno es obligatorio.",
      "manufacturerPartId": "ID de pieza del fabricante",
      "customerPartId": "ID de pieza del cliente",
      "eitherPartIdRequired": "Se requiere el ID de pieza del fabricante o el ID de pieza del cliente."
    }
  },
  "cyberSecurityKPIs": {
    "title": "Métricas de ciberseguridad",
    "historyTitle": "Historial de métricas de ciberseguridad enviadas",
    "historySubTitle": "Aquí puedes ver el historial de datos compartido",
    "description": "Bienvenido al fácil de usar para compartir datos de ciberseguridad con vosotros OEM",
    "nothinghere": "¡Nada aquí todavía!",
    "newEntryAppearance": "Cuando crees una nueva entrada, aparecerá aquí.",
    "createKPITitle": "Crear y enviar métricas de ciberseguridad",
    "createKPISubTitle": "Por favor, asegúrate de completar todos los detalles de una vez. Los datos no se guardarán si decides cancelar antes de enviarlos. Si decides cancelar, serás redirigido al panel de casos de uso y tendrás que rellenar los datos desde el principio.",
    "createKPIDocumentationDesclaimer": "Para más información sobre cómo rellenar el formulario y otros requisitos del OEM, por favor sigue nuestra {documentation}.",
    "documentation": "Documentación",
    "generalInformation": "General information",
    "measurementYear": "Año de medición",
    "receiverBpn": "BPN del receptor",
    "confirmationText": "Al presentar la solicitud, entiendo que el contrato se negociará sobre la oferta de datos según las políticas establecidas por el proveedor de datos.",
    "successTitle": "Éxito",
    "successDescription": "Tus datos se comparten con éxito. El id de trabajo es {id}",
    "sendMetricsFailed": "Error al compartir tus datos.",
    "kpiKnowledgeBase": "Aprende más sobre el caso de uso",
    "kpiFirstEntry": "Empieza y crea tu primera entrada",
    "metricsInformation": {
      "title": "Información de métricas",
      "measurementDate": "Fecha de medición",
      "value": "valor",
      "kpiNotSharedReason": "Razón para no compartir la métrica",
      "enclosedSiteTitle": "Sitios cerrados",
      "enclosedSiteLabel": "Selecciona tus sitios cerrados"
    },
    "modal": {
      "leaveTitle": "¿Salir sin guardar?",
      "leaveDescription": "Si cierras este formulario ahora, tus datos introducidos se perderán.",
      "discardBtn": "Descartar cambios",
      "continueEditingBtn": "Continuar editando",
      "confirmTitle": "Confirmar envío",
      "confirmDescription": "Una vez enviado, este mensaje no puede ser editado ni recuperado.",
      "confirmReviewBtn": "Revisar de nuevo"
    },
    "helpCard": {
      "title": "¿Cómo funciona?",
      "description": "Comparta los datos anuales de KPI de ciberseguridad con BMW. Obtenga aquí una visión completa de toda la información registrada previamente.",
      "subtitle": "¿Quiere saber más sobre el caso de uso de las métricas de ciberseguridad?"
    },
    "metricsViewer": {
      "jobId": "ID de trabajo",
      "threadId": "ID de hilo",
      "stepId": "ID de paso",
      "header": "Cabeceras",
      "messageId": "ID de mensaje",
      "senderBpn": "BPN del remitente",
      "receiverBpn": "BPN del receptor",
      "senderFeedbackUrl": "URL de retroalimentación del remitente",
      "content": "Contenido",
      "reportId": "ID de informe",
      "kpiShared": "KPI compartido"
    }
  },
  "publicationTemplates": {
    "title": "Mis plantillas de publicación",
    "deletedTemplates": "Mis plantillas eliminadas",
    "showDeletedTemplates": "Mostrar plantillas eliminadas",
    "hideDeletedTemplates": "Mostrar plantillas activas",
    "newTemplate": "Nueva plantilla",
    "create": {
      "title": "Crear plantilla de publicación",
      "edit": "Editar plantilla de publicación",
      "templateName": "Nombre de la plantilla",
      "templateType": "Plantilla de {type}",
      "create": "Crear",
      "update": "Actualizar",
      "modifiedAt": "Modificado en",
      "accessPolicyId": "Política de acceso",
      "usagePolicyId": "Política de uso",
      "isEnabled": "Está habilitado",
      "targetCompany": "Empresa objetivo",
      "targetConnectors": "Conectores objetivo",
      "selectCountry": "Selecciona un país",
      "templateDetails": "Detalles de la plantilla de publicación",
      "assetsCriteria": "Criterios de selección de activos",
      "connectorDetails": "Detalles del conector"
    },
    "delete": {
      "title": "Eliminar plantilla de publicación",
      "description": "¿Estás seguro de que deseas eliminar esta plantilla?",
      "button": "Eliminar"
    }
  },
  "contracts": {
    "title": "Detalles de acuerdos de contrato",
    "provider": {
      "description": "Esta es una visión general de los acuerdos de contrato que tu organización tiene con otros participantes del espacio de datos.",
      "note": "Tenga en cuenta que la lista a continuación muestra los datos de todos los casos de uso. Pronto introduciremos una lista de datos prefiltrada, así como búsqueda y filtrado avanzados por caso de uso. Mientras tanto, utilice las opciones de búsqueda y filtrado para encontrar datos relevantes en la lista a continuación.",
      "howItWorks": {
        "description": "Aquí puedes encontrar todos tus acuerdos de datos suscritos o negociados en varios espacios de datos. Puedes filtrar los resultados para un conector en particular o simplemente buscar con un ID de acuerdo de contrato o ID de activo. También puedes ordenar la lista para ver los acuerdos de datos según tus necesidades. Además, puedes seleccionar las ofertas de datos y exportarlas localmente si lo deseas.",
        "subtitle": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?"
      },
      "details": {
        "title": "Detalles de acuerdos de contrato proporcionados",
        "description": "Descripción",
        "content": "Contenido",
        "agreementDetails": "Detalles del acuerdo",
        "assetDetails": "Detalles del activo",
        "usagePolicy": "Política de uso"
      }
    },
    "consumer": {
      "description": "Esta es una visión general de los acuerdos de contrato que tu organización tiene para ofertas de datos de otros participantes del espacio de datos",
      "downloadData": "Descargar datos",
      "downloadAgreement": "Descargar acuerdo",
      "reinitiate": "Iniciar transferencia y descargar datos",
      "error": {
        "heading": "¡Lo sentimos! Parece que ya has negociado este contrato.",
        "body": "No puedes volver a negociar un contrato ya negociado. Puedes encontrar los detalles del contrato a continuación y también puedes descargar este acuerdo y suscribirte a los datos."
      },
      "details": {
        "title": "Detalles de acuerdos de contrato consumidos"
      },
      "howItWorks": {
        "description": "Aquí puedes encontrar todos tus acuerdos de datos suscritos o negociados en varios espacios de datos. Puedes filtrar los resultados para un conector en particular o simplemente buscar con un ID de acuerdo de contrato o ID de activo. También puedes ordenar la lista para ver los acuerdos de datos según tus necesidades. Además, puedes seleccionar las ofertas de datos y exportarlas localmente si lo deseas.",
        "subtitle": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?"
      }
    }
  },
  "provider": {
    "provider": "Proveedor",
    "assets": {
      "title": "Mis activos",
      "offeredBy": "Ofrecido por:",
      "offers": "Ofertas",
      "created": "Creado",
      "modifiedAt": "Modificado en",
      "noResultsFound": "No se encontraron activos",
      "success": "Activo creado con éxito",
      "updateSuccess": "Activo actualizado con éxito",
      "buttons": {
        "createOffer": "Crear oferta",
        "details": "Ver detalles",
        "delete": "Eliminar activo",
        "create": "Crear activo",
        "edit": "Editar activo",
        "update": "Actualizar activo",
        "showDeleted": "Mostrar activos eliminados",
        "hideDeleted": "Ocultar activos eliminados",
        "restore": "Restaurar activo",
        "add": "Agregar par clave-valor",
        "addJson": "Agregar objeto json",
        "editJson": "Editar objeto json",
        "saveJson": "Guardar JSON",
        "advanceAddition": "Adición avanzada",
        "unpublish": "Activo no publicado",
        "showAssets": "Mostrar activos"
      },
      "detailsDialog": {
        "title": "Detalles del activo"
      },
      "createDialog": {
        "title": {
          "general": "Crear nuevo activo",
          "edit": "Editar activo",
          "addProperties": "Agregar propiedades",
          "advance": "Adición avanzada de propiedades"
        },
        "publicProps": "Propiedades públicas",
        "privateProps": "Propiedades privadas",
        "dataAddress": "Dirección de datos",
        "dataSources": "Fuente de datos",
        "dataDestination": "Destino de datos",
        "json": {
          "fields": "Campos Json",
          "editor": "Editor de propiedades personalizadas",
          "formatted": "Visor de propiedades personalizadas",
          "error": "JSON inválido:",
          "placeholder": "Ingrese JSON de propiedades personalizadas"
        },
        "connectionTypeLabel": {
          "http": "Introducir la URL",
          "s3": "Introducir el nombre del objeto",
          "azure": "Introducir el nombre del blob",
          "sftp": "Introducir el nombre del archivo"
        },
        "fields": {
          "name": "Nombre",
          "namePlaceholder": "Introduce el nombre de la oferta",
          "description": "Descripción",
          "version": "Versión",
          "contentType": "Tipo de contenido",
          "contentTypePlaceholder": "Introduce el tipo de contenido",
          "keywords": "Palabras clave",
          "language": "Idioma",
          "languagePlaceholder": "Selecciona el idioma",
          "semanticId": "ID semántico",
          "semanticIdPlaceholder": "Por favor, introduce el ID semántico",
          "dct:type": "dct:tipo",
          "dct:typePlaceholder": "Elige un tipo dct",
          "keywordsPlaceholder": "Agregar palabras clave",
          "descriptionPlaceholder": "Escribe la descripción de la oferta",
          "versionPlaceholder": "Número de versión",
          "dataType": "Tipo de dirección de datos",
          "dataTypePlaceholder": "Selecciona el tipo de dirección de datos",
          "dataAddressUrl": "URL del activo",
          "dataAddressUrlPlaceholder": "Introduce la URL del activo",
          "targetCompany": "Empresa objetivo",
          "targetCompanyPlaceholder": "Introduce una empresa objetivo",
          "country": "País",
          "countryPlaceholder": "Introduce un país",
          "key": "Clave",
          "keyPlaceholder": "Introduce la clave",
          "value": "Valor",
          "valuePlaceholder": "Introduce el valor",
          "assetType": "Tipo de activo",
          "assetTypePlaceholder": "Introduce el tipo de activo"
        },
        "validation": {
          "name": "Por favor, introduce un nombre",
          "assetType": "Por favor, selecciona un tipo de activo",
          "contentType": "Por favor, introduce un tipo de contenido válido",
          "dataType": "Por favor, selecciona un tipo de datos válido",
          "targetCompany": "Por favor, introduce una empresa objetivo válida",
          "country": "Por favor, introduce un país válido"
        }
      },
      "tags": {
        "restricted": "Acceso restringido",
        "unrestricted": "Sin restricciones"
      },
      "search": {
        "title": "Filtros de búsqueda",
        "helperText": "Busca por nombre de activo, fecha de creación o tipo",
        "filters": {
          "byName": "Nombre del activo",
          "byType": "Tipo de activo",
          "byDate": "Fecha de modificación"
        }
      },
      "delete": {
        "title": "Eliminar activo",
        "description": "¿Estás seguro de que deseas eliminar este activo?"
      },
      "unpublish": {
        "title": "Activo no publicado",
        "description": "¿Estás seguro de que quieres no publicar este activo?"
      }
    },
    "fileUploadTerms": "Entiendo y confirmo que he completado correctamente toda la información requerida y T-Systems no es responsable en caso de información incorrecta y rechazo de la oferta.",
    "fileUploadInfo": "T-Systems no verifica la validez de la información de metadatos completada aquí. Por favor, asegúrate de haber completado la información correcta y completa.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Entrada única",
    "bulkEntries": "Entradas masivas"
  },
  "home": {
    "title": "Conectar e integrar",
    "welcomeBack": "Bienvenido de nuevo"
  },
  "gettingStarted": {
    "title": "¿Necesitas ayuda para comenzar?",
    "openWizard": "Abrir asistente",
    "yourDataOffering": "Tu oferta de datos",
    "yourAssets": "Activos",
    "yourPolicies": "Mis políticas",
    "preconfiguredCatalogue": "Catálogo preconfigurado",
    "contractAgreements": "Acuerdos de contrato",
    "incomingAgreements": "Acuerdos entrantes",
    "outgoingAgreements": "Acuerdos salientes",
    "connectors": "Tus conectores",
    "providedAgreements": "Acuerdos de contrato proporcionados",
    "consumedAgreements": "Acuerdos de contrato consumidos",
    "totalContracts": "Total de contratos"
  },
  "yourConnection": {
    "title": "Tus conectores",
    "viewAllConnection": "Ver todos los conectores",
    "help": "Ayuda",
    "documentation": "Conoce tu Connect & Integrate",
    "gettingStarted": "Guía de inicio",
    "noUseCases": "No hay casos de uso disponibles",
    "activeUseCases": "Casos de uso activos",
    "useCasesAvailableToActivate": "Casos de uso disponibles para activar",
    "open": "Abrir",
    "show": "Mostrar",
    "pcfVersionModal": {
      "title": "Versiones de intercambio PCF",
      "description": "Connect & Integrate admite las siguientes versiones PCF y despliegues de reglamentos para el intercambio PCF dentro de la red Catena-X. Selecciona tu opción preferida. Ten en cuenta que las dos versiones no están conectadas.",
      "current": "Actual",
      "deprecated": "Obsoleta",
      "rulebook": "Reglamento",
      "pcfSubmodel": "Submodelo PCF",
      "supportStatus": "Estado del soporte",
      "statusActive": "Activo",
      "statusEol": "Fin de vida",
      "saturn": {
        "name": "Saturn",
        "description": "Última versión con funciones mejoradas y soporte completo para los estándares actuales de sostenibilidad. Recomendada para todas las implementaciones."
      },
      "jupiter": {
        "name": "Jupiter",
        "description": "Versión heredada mantenida para compatibilidad con versiones anteriores. Se recomienda encarecidamente la migración a Saturn antes del final del período de soporte."
      }
    }
  },
  "wizardSelectionPopup": {
    "whatToLike": "¿Qué te gustaría hacer hoy?",
    "prepare": "Preparar",
    "govern": "Gobernar",
    "provide": "Proveer",
    "consume": "Consumir",
    "howToProvide": "¿Cómo te gustaría proveer datos hoy?",
    "manual": "Manual",
    "automated": "Automatizado vía API",
    "selectUseCases": "Selecciona tus casos de uso",
    "selectSingleUseCase": "Selecciona tu caso de uso",
    "selectDigitalTwin": "Selecciona tu tipo de gemelo digital",
    "back": "Atrás",
    "publish": "Entiendo los requisitos del marco del espacio de datos y acepto publicar la oferta de datos en el espacio de datos en nombre de mi organización."
  },
  "createOffer": {
    "title": {
      "standard": "Crear oferta de datos",
      "pcf": "Crear oferta de datos PCF",
      "certificate": "Crear oferta de certificado",
      "traceability": "Crear oferta de datos de Trazabilidad"
    },
    "publish": "Publicar",
    "legalConfirmation": "Entiendo los requisitos del marco del espacio de datos y acepto publicar la oferta de datos en el espacio de datos en nombre de mi organización.",
    "wizard": {
      "provisionAsset": "Proveer activo",
      "dataUpload": "Selección de datos",
      "attachPolicy": "Adjuntar política",
      "publishDataOffer": "Publicar oferta de datos"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "¿Para qué submodelo te gustaría crear una oferta de datos?",
      "selectSubmodel": "Selecciona submodelo",
      "selectUsecase": "Selecciona un caso de uso",
      "selectDigitalTwinType": "Selecciona un tipo de gemelo digital",
      "whichTypeToSelect": "¿Qué tipo debo seleccionar?",
      "generalInformation": "Información general",
      "description": "Descripción",
      "contentType": "Tipo de contenido",
      "keywords": "Palabras clave",
      "language": "Idioma",
      "location": {
        "title": "Ubicación y direccionamiento",
        "text": "Por favor, introduce los detalles de tu activo"
      },
      "username": "Usuario",
      "password": "Contraseña",
      "assetUrl": "URL del activo",
      "assetUrlPlaceHolder": "Por favor, introduce la URL de tu activo",
      "clientId": "ID de cliente",
      "clientSecret": "Secreto de cliente",
      "tokenUrl": "URL del token",
      "tokenUrlPlaceHolder": "Por favor, introduce la URL de tu token",
      "provideAssets": "Proveer activo",
      "selectConnectorLabel": "Selecciona a qué conector(es) te gustaría compartir tus datos",
      "selectConnectorPlaceholder": "Selecciona un conector",
      "selectRestApiType": "Selecciona tipo de REST-API",
      "selectedAuthMethod": "Método de autenticación"
    },
    "dataUpload": {
      "selectUploadType": "Seleccione su tipo de carga",
      "selectedDataModel": "Selecciona tus datos",
      "csvUpload": {
        "title": "Archivo CSV",
        "description": "Arrastra y suelta tus archivos aquí",
        "uploadFile": "Seleccionar archivo",
        "uploadFileDescription": "Prepara y sube el archivo que deseas intercambiar. Puedes descargar el archivo de muestra para ayudarte a comenzar con el formato requerido para Catena-X.",
        "uploadFileDescriptionNote1": "Descarga el archivo de plantilla desde el siguiente enlace",
        "uploadFileDescriptionNote2": "Rellena el archivo proporcionado con los detalles de tus socios",
        "uploadFileDescriptionNote3": "Sube el archivo en el área proporcionada",
        "partnerValidationNote": "Si deseas saber más sobre la validación de socios, por favor",
        "clickHere": "haz clic aquí",
        "downloadTemplate": "Descargar plantilla",
        "downloadSampleCsv": "Descargar muestra csv",
        "supportedFileTypes": "Tipos de archivos compatibles:"
      },
      "jsonUpload": {
        "title": "JSON",
        "submodelJson": "JSON del submodelo",
        "downloadTemplate": "Descargar plantilla",
        "downloadSampleJson": "Descargar muestra json",
        "uploadFileDescription": "Prepara y sube el archivo que deseas intercambiar.",
        "invalidJson": "El contenido proporcionado no es un JSON válido. Por favor, comprueba la entrada e inténtalo de nuevo.",
        "schemaValidationFailed": "La validación del esquema Catena-X falló",
        "issue": "problema",
        "issues": "problemas"
      },
      "operationMode": {
        "title": "Seleccionar modo de operación",
        "description": "Ahora decida cómo se obtiene el shell para este gemelo.",
        "createNew": {
          "title": "Crear nuevo gemelo digital",
          "description": "Registrar un nuevo shell AAS en CX-Core"
        },
        "useExisting": {
          "title": "Usar gemelo digital existente",
          "description": "Vincular a un shell que ya está en CX-Core"
        }
      },
      "useExisting": {
        "searchTitle": "Buscar shell existente en CX-Core",
        "catenaXId": "ID de Catena-X",
        "search": "Buscar",
        "reset": "Restablecer",
        "noResults": "No se encontraron gemelos digitales coincidentes.",
        "searchError": "Error al buscar gemelos digitales. Inténtalo de nuevo.",
        "matchingTypeNote": "Solo se muestran los shells que coinciden con el tipo de gemelo digital seleccionado.",
        "propertiesTitle": "Propiedades del gemelo digital",
        "readOnly": "(solo lectura)"
      },
      "digitalTwinProperties": {
        "title": "Propiedades del gemelo digital",
        "specificAssetIds": "ID de activos específicos"
      },
      "tableUpload": {
        "title": "Tabla",
        "description": "Proporciona entradas de tabla personalizadas",
        "add": "Agregar"
      },
      "fileUpload": {
        "title": "Subir archivo",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Almacenamiento de objetos",
        "description": "AWS, Azure, OTC o GCP"
      },
      "sftp": {
        "title": "Servidor SFTP",
        "description": "transferencia vía SFTP"
      },
      "apiUpload": {
        "title": "API DESCANSO",
        "description": "transferencia vía API",
        "authAndIdentiTitle": "Autenticación e identificación",
        "authAndIdentiDesc": "Por favor, introduce los detalles de autenticación de tu sistema de destino",
        "selectApiType": "Selecciona tipo de REST-API",
        "locationAndAddrTitle": "Ubicación y direccionamiento",
        "locationAndAddrDesc": "Por favor, introduce los detalles de tu activo",
        "assetUrl": "URL del activo",
        "username": "Usuario",
        "password": "Contraseña",
        "clientId": "ID de cliente",
        "clientSecret": "Secreto de cliente"
      }
    },
    "fileUpload": {
      "title": "Arrastra y suelta tu archivo aquí",
      "btnText": "Seleccionar archivo"
    },
    "attachPolicy": {
      "title": "Adjunta una política a esta oferta de datos",
      "createPolicy": "Crear nueva política",
      "bpnFieldTitle": "¿Con quién deseas intercambiar tus datos?",
      "howItWork": {
        "title": "¿Cómo funciona?",
        "description": "Preconfiguramos las políticas según el acuerdo marco de casos de uso de Catena-X. El acceso a tus datos solo se permitirá para los Números de Socio Comercial proporcionados.",
        "knowMore": "¿Quieres saber más sobre las políticas?",
        "documentation": "Documentación"
      },
      "accessPolicyTableText": "Adjunta una política de acceso a esta oferta de datos",
      "usagePolicyTableText": " Adjunta una política de uso a esta oferta de datos",
      "heading": {
        "title": "Adjunta políticas existentes o crea nuevas",
        "description": "Por favor, adjunta tanto la política de acceso como la de uso de las tablas a continuación para finalizar la publicación de la oferta de datos. También puedes buscar políticas por nombre o crear una nueva política si aún no tienes la deseada."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Detalles de la oferta de datos",
      "generalInformation": "Información general",
      "attribute": "Atributo",
      "value": "Valor",
      "knowMore": "Saber más sobre tu oferta de datos",
      "attachedDataAssets": "Elementos adjuntos",
      "attachedPolicies": "Políticas adjuntas",
      "allowPolicyPublish": "Permito la publicación de la política",
      "publish": "Publicar",
      "verifiedLegalEntity": "Entidad legal verificada por",
      "dataOfferCreatedBy": "Oferta de datos creada por: ",
      "contactOrgAdmin": "Contactar al administrador de la organización",
      "help": "Ayuda",
      "attachedDataAsset": "Activo de datos adjunto",
      "attachedAccessPolicy": "Política de acceso adjunta",
      "attachedUsagePolicy": "Política de uso adjunta",
      "publishedConnectors": "Conectores a los que se publicará esta oferta",
      "knowMoreConnector": "Saber más sobre tus conectores",
      "knowMorePolicies": "Saber más sobre tus políticas",
      "knowMoreDataAssets": "Saber más sobre tus activos de datos",
      "knowMoreDataOffers": "Saber más sobre tu oferta de datos",
      "publishCheckboxLabel": "Yo, en nombre de mi organización, acepto publicar la oferta de datos y los activos en el espacio de datos. Confirmo el uso de las políticas asociadas para gobernar el espacio de datos y las políticas asociadas y seguiré el marco del espacio de datos para cualquier operación sobre la oferta y los activos una vez publicados."
    },
    "result": {
      "success": {
        "title": "Solicitud exitosa.",
        "description": "¡El proceso de publicación del activo ha comenzado! El id del trabajo es {id}"
      }
    },
    "success": {
      "title": "Tu oferta de datos ya está publicada",
      "description": "Tu oferta de datos ya está publicada, haz clic en lo siguiente para los próximos pasos",
      "createOffer": "Crear otra oferta de datos",
      "createOfferButton": "Crear",
      "goToHome": "Ir al inicio",
      "goToHomeButton": "Ir al inicio",
      "uploadHistory": "Consulta tu historial de cargas"
    }
  },
  "policy": {
    "newPolicy": "Nueva política",
    "showDeletedPolicies": "Mostrar políticas eliminadas",
    "myDeletedPolicies": "Mis políticas eliminadas",
    "hideDeletedPolicies": "Mostrar políticas activas",
    "restoreAsset": "Restaurar",
    "publishDeletion": "Publicar eliminación",
    "create": {
      "title": "Crear nueva política",
      "edit": "Editar política",
      "policyName": "Nombre de la política",
      "policyType": "Política de {type}",
      "accessPolicy": "Política de acceso",
      "usagePolicy": "Política de uso",
      "create": "Crear y guardar",
      "update": "Actualizar"
    },
    "delete": {
      "title": "Eliminar política",
      "description": "¿Estás seguro de que deseas eliminar esta política?",
      "button": "Eliminar"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Número de socio comercial",
        "description": "La restricción del número de socios comerciales se puede utilizar para definir qué socios comerciales exactos (según BPNL) pueden ver o negociar la oferta de datos respectiva. "
      },
      "BusinessPartnerGroup": {
        "title": "Grupo de socios comerciales",
        "description": "La restricción del grupo de socios comerciales se puede utilizar para definir qué socios comerciales exactos (según BPNL) pueden ver o negociar la oferta de datos respectiva. "
      },
      "Membership": {
        "title": "Afiliación",
        "description": "La credencial de membresía se puede utilizar para garantizar que solo los miembros de CX puedan ver o negociar la oferta de datos respectiva."
      },
      "ContractReference": {
        "title": "Referencia del contrato",
        "description": "La restricción de referencia del contrato se puede utilizar para definir bajo qué detalles del contrato bilateral se comparten los datos. "
      },
      "Dismantler": {
        "title": "Desmantelador",
        "description": "Las empresas que poseen la credencial son empresas certificadas como desmanteladoras.",
        "allowedBrands": {
          "title": "Marcas permitidas del desmantelador",
          "description": "Función de la empresa que define un desmantelador. Las empresas que poseen la credencial son empresas certificadas como desmanteladoras."
        }
      },
      "UsagePurpose": {
        "title": "Propósito de uso",
        "description": "Propósito de uso"
      },
      "FrameworkAgreement": {
        "title": "Acuerdo Marco",
        "description": "Con la credencial FrameworkAgreement, solo aquellos participantes que hayan firmado el acuerdo marco respectivo (general o mediante una versión específica) pueden ver o negociar la oferta de datos respectiva. "
      },
      "Duration": {
        "title": "Duración",
        "description": "Duración del uso de datos desde la fecha de firma."
      },
      "inForceDate": {
        "title": "Rango de fechas fijas",
        "description": "Marco de tiempo de fecha fija para el uso de datos."
      },
      "connector": {
        "title": "Restricción del conector",
        "description": "Las empresas que poseen los conectores para utilizarlos tienen restricciones."
      },
      "AffiliatesBpnl": {
        "title": "Filiales",
        "description": "Documenta (no verifica) los socios comerciales afiliados."
      },
      "AffiliatesRegion": {
        "title": "Región de filiales",
        "description": "Documenta (no verifica) las regiones de las filiales."
      },
      "ConfidentialInformationMeasures": {
        "title": "Medidas de información confidencial",
        "description": "Documenta (no verifica) si se deben tomar medidas confidenciales."
      },
      "ConfidentialInformationSharing": {
        "title": "Compartición de información confidencial",
        "description": "Documenta (no verifica) si se deben tomar medidas confidenciales."
      },
      "ContractTermination": {
        "title": "Terminación del contrato",
        "description": "Documenta (no verifica) qué debe hacer el consumidor con los datos después de la terminación del contrato."
      },
      "DataFrequency": {
        "title": "Frecuencia de datos",
        "description": "Documenta (no verifica) con qué frecuencia se puede transferir el activo."
      },
      "DataProvisioningEndDate": {
        "title": "Fin de provisión de datos",
        "description": "Documenta (no verifica) una fecha absoluta en la que finaliza la provisión del activo."
      },
      "DataProvisioningEndDurationDays": {
        "title": "Días de provisión de datos",
        "description": "Documenta (no verifica) cuánto tiempo dura la provisión del activo."
      },
      "DataUsageEndDate": {
        "title": "Fin de uso de datos",
        "description": "Documenta (no verifica) una fecha absoluta en la que finaliza el consumo del activo."
      },
      "DataUsageEndDurationDays": {
        "title": "Días de uso de datos",
        "description": "Documenta (no verifica) cuánto tiempo dura el consumo del activo."
      },
      "DataUsageEndDefinition": {
        "title": "Definición del fin de uso de datos",
        "description": "Documenta (no verifica) cuánto tiempo dura el consumo del activo."
      },
      "JurisdictionLocation": {
        "title": "Ubicación de la jurisdicción",
        "description": "Documenta (no verifica) la jurisdicción de este contrato en texto claro"
      },
      "JurisdictionLocationReference": {
        "title": "Referencia de ubicación de la jurisdicción",
        "description": "Documenta (no verifica) la jurisdicción de este contrato respecto a las partes involucradas"
      },
      "Liability": {
        "title": "Responsabilidad",
        "description": "Documenta (no verifica) la responsabilidad de este contrato frente a las partes involucradas"
      },
      "ManagedLegalEntityBpnl": {
        "title": "Entidad legal gestionada",
        "description": "Documenta (no verifica) los socios comerciales para los que el proveedor gestiona el activo."
      },
      "ManagedLegalEntityRegion": {
        "title": "Región de entidad legal gestionada",
        "description": "Documenta (no verifica) la región para la cual el proveedor gestiona el activo."
      },
      "Precedence": {
        "title": "Precedencia",
        "description": "Documenta (no verifica) qué marco contractual tiene precedencia"
      },
      "ExclusiveUsage": {
        "title": "Uso exclusivo",
        "description": "Documenta (no verifica) que este activo se ofrece exclusivamente al consumidor"
      },
      "UsageRestriction": {
        "title": "Restricción de uso",
        "description": "Documenta (no verifica) lo que el consumidor no puede hacer con este activo"
      },
      "VersionChanges": {
        "title": "Cambios de versión",
        "description": "Documenta (no verifica) qué tipo de cambios de versión pueden ocurrir en el activo"
      },
      "Warranty": {
        "title": "Garantía",
        "description": "Documenta (no verifica) qué garantía obtiene el consumidor por el activo"
      },
      "WarrantyDefinition": {
        "title": "Definición de garantía",
        "description": "Documenta (no verifica) el período de garantía que obtiene el consumidor por el activo"
      },
      "WarrantyDurationMonths": {
        "title": "Duración de la garantía",
        "description": "Documenta (no verifica) el período de garantía que obtiene el consumidor por el activo en meses."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Número de socio comercial",
      "tx:BusinessPartnerGroup": "Grupo de socios comerciales",
      "cx-policy:Membership": "Afiliación",
      "cx-policy:ContractReference": "Referencia del contrato",
      "cx-policy:Dismantler.allowedBrands": "Marcas permitidas del desmantelador",
      "cx-policy:Dismantler": {},
      "cx-policy:UsagePurpose": "Propósito de uso",
      "cx-policy:FrameworkAgreement": "Acuerdo Marco",
      "duration": "Duración",
      "unit": "Unidad",
      "fromdate": "Desde la fecha",
      "todate": "Hasta la fecha",
      "connector": "Conector",
      "cx-policy:AffiliatesBpnl": "Filiales",
      "cx-policy:AffiliatesRegion": "Región de filiales",
      "cx-policy:ConfidentialInformationMeasures": "Medidas de información confidencial",
      "cx-policy:ConfidentialInformationSharing": "Compartición de información confidencial",
      "cx-policy:ContractTermination": "Terminación del contrato",
      "cx-policy:DataFrequency": "Frecuencia de datos",
      "cx-policy:DataProvisioningEndDate": "Fin de provisión de datos",
      "cx-policy:DataProvisioningEndDurationDays": "Días de provisión de datos",
      "cx-policy:DataUsageEndDate": "Fin de uso de datos",
      "cx-policy:DataUsageEndDurationDays": "Días de uso de datos",
      "cx-policy:DataUsageEndDefinition": "Definición del fin de uso de datos",
      "cx-policy:JurisdictionLocation": "Ubicación de la jurisdicción",
      "cx-policy:JurisdictionLocationReference": "Referencia de ubicación de la jurisdicción",
      "cx-policy:Liability": "Responsabilidad",
      "cx-policy:ManagedLegalEntityBpnl": "Entidad legal gestionada",
      "cx-policy:ManagedLegalEntityRegion": "Región de entidad legal gestionada",
      "cx-policy:Precedence": "Precedencia",
      "cx-policy:ExclusiveUsage": "Uso exclusivo",
      "cx-policy:UsageRestriction": "Restricción de uso",
      "cx-policy:VersionChanges": "Cambios de versión",
      "cx-policy:Warranty": "Garantía",
      "cx-policy:WarrantyDefinition": "Definición de garantía",
      "cx-policy:WarrantyDurationMonths": "Duración de la garantía"
    }
  },
  "jobs": {
    "jobs": "Trabajos",
    "name": "Nombre",
    "startedAt": "Iniciado en",
    "duration": "Duración",
    "jobDetails": "Detalles del proceso",
    "reload": "Recargar",
    "noDetailsAvailable": "No hay más detalles disponibles para este trabajo",
    "retry": "Reintentar"
  },
  "search-offer": {
    "pageTitle": "Buscar ofertas de datos",
    "pcfTitle": "Buscar ofertas de datos PCF",
    "pcfV9Title": "Buscar ofertas de datos PCF v9",
    "certificateTitle": "Buscar ofertas de certificados de socios comerciales",
    "filter": {
      "bpnSearch": "Buscar por tu número de socio comercial o nombre de empresa",
      "bpnSearchNote": "Encuentra las ofertas de datos buscando por el nombre de la empresa o BPN.",
      "manufacturePartId": "ID de pieza del fabricante",
      "manufacturePartIdNote": "Busca todas las ofertas de datos que coincidan con el ID de pieza dado.",
      "enter": "Introduce {field}",
      "connectorUrl": "URL del conector",
      "connectorUrlNote": "Busca datos dentro de conectores específicos",
      "subModel": "Submodelo",
      "subModelNote": "Ajusta tus resultados de búsqueda para tu caso de uso deseado",
      "search": "Buscar",
      "searchBy": "Buscar por",
      "resetFilters": "Restablecer filtros",
      "advancedSearch": "Búsqueda avanzada",
      "dct:type": "dct:tipo",
      "assetId": "ID de activo"
    },
    "noResult": {
      "title": "Sin resultados",
      "description": "Por favor, realiza una búsqueda para explorar las ofertas de datos disponibles en la red"
    },
    "helpCard": {
      "title": "¿Cómo funciona?",
      "description": "Descubre el catálogo de ofertas de datos de otros participantes del espacio de datos. Puedes buscar, seleccionar y suscribirte a las ofertas de datos disponibles en el espacio de datos.",
      "subtitle": "¿Quieres saber más sobre cómo funciona la negociación y el consumo de ofertas de datos?",
      "documentation": "Documentación"
    },
    "offers": {
      "downloadSelected": "Descargar seleccionados",
      "transferSelected": "Transferir seleccionados",
      "negotiate": "Negociar",
      "noOffer": "No hay ofertas de datos disponibles."
    },
    "offer-details": {
      "title": "Confirmar negociaciones de contrato",
      "description": "Descripción",
      "attachedPolicies": "Políticas adjuntas",
      "termsCheck": "Acepto los términos del contrato y deseo iniciar la negociación del contrato y el intercambio de datos.",
      "negotiate": "Negociar",
      "negotiateAndDownload": "Negociar y descargar",
      "negotiateAndTransfer": "Negociar y transferir",
      "transfer": "Transferir",
      "cancel": "Cancelar",
      "attribute": "Atributo",
      "value": "Valor",
      "endpointUrl": "URL del endpoint",
      "organization": "Organización",
      "bpnNumber": "Número BPN",
      "manufacturerPartId": "ID de pieza del fabricante",
      "noOfAssets": "Número de activos seleccionados",
      "membership": "Membresía",
      "dismantlerBrands": "Marcas permitidas para desmanteladores",
      "frameworkAgreement": "Acuerdo marco",
      "dismantler": "Desmantelador",
      "backToAssets": "Volver a activos",
      "noPolicyMatchTitle": "Activos no negociados o políticas no idénticas",
      "noPolicyMatchText": "Estás intentando descargar algunos activos que aún no están negociados. O algunos de los activos que intentas negociar no tienen políticas idénticas. Por favor, selecciona los activos correctos y continúa.",
      "negotiateInProgress": "Negociación y descarga en progreso",
      "negotiateAndDownloadSuccess": "Negociación y descarga completadas con éxito",
      "negotiateAndTransferSuccess": "Negociación y transferencia completadas con éxito",
      "transferSuccess": "Transferencia completada con éxito",
      "progress": "Progreso",
      "fetchShell": "Obtener shell",
      "exportToCSV": "Exportar a CSV",
      "fetchJobFailed": "Error al obtener detalles del trabajo",
      "negotiateError": "Error al descargar activos",
      "dtr": "Registro de gemelos digitales",
      "edc": "Activos del conector",
      "browseDtr": "Explorar DTR"
    },
    "existingContracts": {
      "heading": "Contratos disponibles",
      "description": "¡Aquí vendrá una descripción extraordinaria!"
    },
    "dtr": {
      "title": "Gemelos digitales",
      "shells": "Explorar shells",
      "description": "Vas a negociar automáticamente la obtención y exportación de Shells del registro de gemelos digitales del proveedor seleccionado",
      "noPoliciesFound": "No se encontraron políticas para este activo",
      "errorFetchingPolicies": "Error al recuperar políticas. ",
      "negotiate": "Negociar"
    },
    "traceabilityTitle": "Descubra los datos de trazabilidad"
  },
  "assetUploadHistory": {
    "title": "Historial de carga de activos",
    "subtitle": "Este historial muestra las transacciones en los conectores del espacio de datos de tu empresa. Todas las actividades en activos, políticas y definiciones de contrato se enumeran aquí.",
    "refresh": "Actualizar",
    "processId": "ID de proceso",
    "providerUrl": "URL del proveedor",
    "createdOn": "Creado en",
    "totalItems": "Total de elementos",
    "successful": "Exitoso",
    "failed": "Fallido",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de finalización",
    "howItWork": {
      "title": "¿Cómo funciona?",
      "description": "Puedes encontrar el historial de todos tus activos subidos en diferentes espacios de datos. Puedes volver a descargar los archivos localmente o transferirlos a una ubicación externa. En caso de errores, debes volver a intentar la descarga o renegociar la oferta de datos.",
      "moreInfo": "¿Quieres saber más sobre el historial de cargas y qué puedes hacer aquí?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "El historial te proporciona una visión general de los datos descargados de tu organización disponibles a partir de los contratos negociados en el espacio de datos. Si es necesario, puedes volver a descargar los datos desde esta lista de historial.",
    "howItWorks": {
      "description": "Puedes encontrar el historial de todos tus activos descargados en diferentes espacios de datos. Puedes volver a descargar los archivos localmente o transferirlos a una ubicación externa. En caso de errores, debes volver a intentar la descarga o renegociar la oferta de datos.",
      "moreInfo": "¿Quieres saber más sobre el historial de descargas y qué puedes hacer aquí?"
    },
    "downloadError": "Descarga no exitosa, ¡por favor, inténtalo de nuevo!",
    "viewErrors": "Ver errores",
    "processId": "ID de proceso"
  },
  "digitalTwinBrowser": {
    "subHeading": "Estos son tus gemelos digitales y sus submodelos. Tus gemelos digitales están expuestos al espacio de datos a través de tu Registro de Gemelos Digitales.",
    "noDocumentError": "No hay aspectDocument para el id actual",
    "nameNotProvided": "Nombre no proporcionado",
    "fetchDigitalTwinsError": "Error al obtener gemelos digitales",
    "fetchAspectDocumentError": "Error al obtener el documento de aspecto",
    "fetchAspectModelError": "Error al obtener el modelo de aspecto",
    "detailsOverviewModalTitle": "Detalles del aspecto",
    "addItem": "Agregar elemento",
    "detailsTable": {
      "idShort": "ID corto",
      "displayName": "Nombre para mostrar",
      "modelUrn": "URN del modelo"
    },
    "shellsTable": {
      "manufacturer": "ID de pieza del fabricante",
      "modifiedBy": "Usuario",
      "modifiedAt": "Hora"
    }
  },
  "connector": {
    "addNewConnector": "+ Agregar nuevo conector",
    "searchConnector": "Buscar por nombre del conector",
    "connectorModal": {
      "error": "Error al obtener los detalles del conector"
    }
  },
  "column": {
    "name": "Nombre",
    "connectorName": "Nombre del conector",
    "contractId": "ID de contrato",
    "productId": "ID de producto",
    "manufacturerPartId": "ID de pieza del fabricante",
    "manufacturerId": "ID del fabricante",
    "digitalTwinType": "Tipo de gemelo digital",
    "correlationId": "ID de correlación",
    "requestId": "ID de solicitud",
    "bpn": "BPN",
    "createdAt": "Creado en",
    "createdBy": "Creado por",
    "attribute": "Atributo",
    "value": "Valor",
    "url": "URL",
    "actions": "Acciones",
    "lastUpdatedTime": "Última actualización",
    "status": "Estado",
    "requestedDate": "Fecha solicitada",
    "policyType": "Tipo de política",
    "modifiedBy": "Modificado por",
    "modifiedOn": "Modificado en",
    "syncStatus": "Estado de sincronización",
    "assetId": "ID de activo",
    "assetType": "Tipo de activo",
    "type": "Tipo",
    "createdFrom": "Creado desde",
    "createdTo": "Creado hasta",
    "statusDuration": "Estado/Duración",
    "certifier": "Certificador",
    "version": "Versión",
    "registrationNumber": "N.º de registro",
    "validUntil": "Válido hasta",
    "offerId": "Id. de oferta",
    "errorMessage": "Mensaje de error",
    "globalAssetId": "ID de activo global",
    "shellName": "Nombre del shell",
    "contractAgreementId": "ID de acuerdo de contrato",
    "signingDate": "Fecha de firma",
    "providerConnectorUrl": "URL del conector del proveedor",
    "consumerConnectorUrl": "URL del conector del consumidor",
    "providerBpnl": "BPNL del proveedor",
    "consumerBpnl": "BPNL del consumidor",
    "counterPartyId": "ID de contraparte",
    "resourceId": "ID de recurso",
    "resourceType": "Tipo de recurso",
    "transactionMethod": "Método de transacción",
    "trustLevel": "Nivel de confianza",
    "partId": "ID de pieza",
    "sentBy": "Enviado por",
    "partner": "Socio",
    "sentOn": "Enviado el",
    "intrinsicId": "Identificación intrínseca",
    "id": "ID",
    "catenaXId": "ID de Catena-X",
    "customerPartId": "ID de pieza del cliente"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Error al obtener mensajes",
    "openRelatedMessage": "Abrir mensaje relacionado",
    "messagesTable": {
      "context": "Contexto",
      "senderBpn": "BPN del remitente",
      "receiverBpn": "BPN del receptor",
      "correlationId": "ID de correlación",
      "jobId": "ID de trabajo",
      "conversationId": "ID de conversación"
    },
    "messageType": {
      "ecu": "ECU",
      "generic": "Genérico",
      "quality": "Calidad",
      "ccmpush": "Empuje CCM",
      "ccmrequest": "Solicitud CCM",
      "ccmstatus": "Estado CCM",
      "ccmavailable": "CCM Disponible",
      "blockNotification": "Notificación de bloqueo",
      "dtrEvent": "Evento DTR",
      "csm": "CSM"
    }
  },
  "bpnSelector": {
    "selectFromList": "Seleccionar de la lista",
    "enterManually": "Ingresar manualmente",
    "selectPlaceholder": "Seleccione una ubicación BPN",
    "manualPlaceholder": "Ingrese BPN (por ejemplo, BPNL123456789ABC)",
    "validFormat": "Formato BPN válido",
    "invalidFormat": "Formato BPN no válido",
    "invalidFormatHint": "Formato: BPNL + 12 caracteres alfanuméricos",
    "formatHint": "Formato: BPNL123456789ABC (16 caracteres en total)",
    "selected": "Seleccionado"
  },
  "searchableSelect": {
    "pressEnterToUse": "Presione Enter para usar este BPNA/BPNS",
    "placeholderText": "Por favor ingrese un BPNA/BPNS válido",
    "placeholder": "Seleccione o ingrese un BPNA/BPNS",
    "validBpnWarning": "¡Advertencia! El valor BPNA/BPNS ingresado no está validado contra ninguna fuente, a diferencia de BP Explore. Si aún desea usarlo, presione Enter.",
    "enterValidBpn": "Ingrese un BPNA/BPNS válido (formato esperado ^(BPNA|BPNS).{12}$)"
  },
  "blockNotifications": {
    "title": "Bloquear notificaciones",
    "description": "Bienvenido a la solución de intercambio de gestión de certificados de socios comerciales de extremo a extremo, fácil de usar en Catena-X.",
    "recentNotifications": "Notificaciones recientes",
    "totalAffected": "Total de partes afectadas",
    "top5": "Los 5 principales socios de intercambio",
    "sendNotifications": "Enviar notificaciones de bloqueo",
    "sendUpdate": "Enviar actualización",
    "sentHistory": "Historial de notificaciones enviadas",
    "receivedHistory": "Historial de notificaciones recibidas",
    "sendDescription": "Cree y comparta los certificados de su sitio en la red Catena-X",
    "learnMore": "Obtenga más información sobre el bloqueo de notificaciones",
    "filters": {
      "lastYear": "Último 1 año",
      "sixMonths": "6 meses",
      "threeMonths": "3 meses",
      "oneMonth": "1 mes",
      "lastWeek": "La semana pasada",
      "selectDateRange": "Seleccionar rango de fechas",
      "bpnOrCompany": "Número de socio comercial o nombre de la empresa"
    },
    "stats": {
      "totalAffectedParts": "Total de partes afectadas",
      "topExchangePartners": "Principales {count} socios de Exchange",
      "sentNotifications": "Notificaciones enviadas",
      "receivedNotifications": "Notificaciones recibidas"
    },
    "sentHistoryDescription": "Utilice el área para gestionar sus solicitudes de datos de certificados de socios.",
    "receivedHistoryDescription": "Vea y administre las notificaciones de bloqueo recibidas de los socios.",
    "table": {
      "conversationName": "Nombre de la conversación",
      "problemId": "ID del problema",
      "partner": "Pareja",
      "bpn": "número BPN",
      "createdAt": "Creado en",
      "partnerName": "Nombre del socio",
      "sentBy": "Enviado por",
      "sentOn": "Enviado el",
      "receivedOn": "Recibido el"
    },
    "errors": {
      "fetchSentNotifications": "No se pudieron recuperar las notificaciones enviadas",
      "fetchStatistics": "No se pudieron cargar las estadísticas de notificaciones",
      "fetchRecentNotifications": "No se pudieron cargar las notificaciones recientes",
      "invalidDateRange": "No se pueden recuperar estadísticas sin un rango de fechas válido",
      "sendNotificationFailed": "No se pudo enviar la notificación de bloqueo. ",
      "validationFailed": "Por favor complete todos los campos obligatorios"
    },
    "confirmationText": "Entiendo y confirmo que he completado correctamente toda la información requerida. ",
    "validityDisclaimer": "T-Systems no comprueba la validez de la información de metadatos aquí completada. ",
    "generalInformation": "Información general",
    "jobName": "Nombre del trabajo",
    "jobNamePlaceholder": "Introduzca el nombre del trabajo",
    "receiverBpn": "Receptor BPN",
    "expectedResponseBy": "Respuesta esperada por",
    "success": {
      "notificationSent": "Notificación de bloqueo enviada correctamente",
      "notificationUpdateSent": "Actualización de notificación de bloqueo enviada con éxito"
    },
    "groups": {
      "notificationInformation": "Información de notificación",
      "blockInformationItems": "Bloquear elementos de información *",
      "partIdentification": "Identificación de piezas",
      "componentLevelContainment": "Contención a nivel de componente",
      "periodAndVolumeLevelContainment": "Contención de nivel de volumen y período",
      "deliveryInformation": "Información de entrega",
      "quantities": "Cantidades",
      "sizeOfProductionLot": "Tamaño del lote de producción",
      "numberOfPartsPerDeliveryNote": "Número de piezas por albarán de entrega",
      "numberOfPartsPerPackage": "Número de piezas por paquete",
      "locationInContainer": "Ubicación en Contenedor (Opcional)"
    },
    "fields": {
      "problemId": "ID del problema",
      "notificationStatus": "Estado de notificación",
      "problemDescription": "Descripción del problema",
      "updateReason": "Motivo de la actualización",
      "catenaXId": "Identificación de Catena-X",
      "blockStatus": "Estado del bloque",
      "manufacturingLocationId": "ID de ubicación de fabricación",
      "customerPartId": "ID de pieza del cliente",
      "integrationLevel": "Nivel de integración",
      "localIdentifiers": "Identificadores locales",
      "key": "Llave",
      "value": "Valor",
      "orderNumber": "Número de orden",
      "deliveryNoteNumber": "Número de albarán de entrega",
      "packageNumber": "Número de paquete",
      "deliveryPlace": "Lugar de entrega",
      "productionDate": "Fecha de producción",
      "deliveryDate": "Fecha de entrega",
      "quantity": "Cantidad",
      "unit": "Unidad",
      "xPosition": "Posición X",
      "yPosition": "Posición Y",
      "smallLoadCarrierLayer": "Capa portadora de carga pequeña"
    },
    "editNotification": "Editar notificación",
    "importJson": {
      "title": "Importar archivo JSON",
      "description": "Cargue un archivo JSON para completar automáticamente el formulario con los datos proporcionados. ",
      "importButton": "Importar desde JSON",
      "dropFileHere": "Arrastre y suelte su archivo JSON aquí",
      "selectFile": "Seleccionar archivo",
      "import": "Importar",
      "success": "Datos del formulario importados correctamente desde JSON",
      "parseError": "No se pudo analizar el archivo JSON",
      "readError": "No se pudo leer el archivo. "
    },
    "partPicker": {
      "button": "Selector de piezas",
      "title": "Selector de piezas",
      "description": "Seleccione gemelos digitales de sus datos de proveedor para completar automáticamente los elementos de información de bloqueo.",
      "addToForm": "Agregar al formulario",
      "success": "{count} elemento(s) de información de bloqueo agregado(s) al formulario.",
      "error": "No se pudieron cargar los detalles del aspecto. Por favor, inténtelo de nuevo."
    },
    "tooltips": {
      "problemDescription": "Un campo de texto libre que proporciona información sobre por qué se deben bloquear las piezas.",
      "updateReason": "Texto libre que describe por qué la lista de piezas dañadas proporcionada anteriormente necesita ser actualizada.",
      "catenaXId": "El ID de Catena-X totalmente anónimo de la pieza o lote serializado.",
      "blockStatus": "Estado de la parte individual dentro de una notificación de bloqueo.",
      "manufacturingLocationId": "Dirección de la ubicación del proveedor desde donde se entregan los componentes."
    },
    "updateNotification": "Notificación de actualización",
    "notificationDetails": "Detalles de notificación",
    "howTo": {
      "description": "Descubre el catálogo de ofertas de datos de otras empresas miembros de Catena-X. Puede enviar y recibir notificaciones de bloqueo. ",
      "doc": "¿Quieres saber más sobre cómo funcionan las notificaciones de bloqueo?"
    }
  },
  "ecu": {
    "title": "Unidad de Control Electrónico (ECU)",
    "description": "Bienvenido a la descripción general fácil de usar para su intercambio de datos de ECU dentro de la red Catena-X.",
    "sentHistory": "Historial de mensajes enviados",
    "receivedHistory": "Historial de mensajes recibidos",
    "sentHistoryDescription": "Ver y gestionar mensajes ECU salientes enviados a socios.",
    "receivedHistoryDescription": "Ver y gestionar mensajes ECU entrantes recibidos de socios.",
    "tiles": {
      "item_1": {
        "title": "Mensajes salientes",
        "description": "Ver los mensajes ECU salientes hacia socios en la red Catena-X"
      },
      "item_2": {
        "title": "Mensajes entrantes",
        "description": "Recibir mensajes entrantes de socios ECU en la red Catena-X"
      },
      "item_3": {
        "title": "Guía de usuario de ECU",
        "description": "Más información sobre el caso de uso de ECU y cómo funciona"
      },
      "item_4": {
        "title": "Documentación para desarrolladores",
        "description": "Acceso rápido a APIs para configurar y gestionar el intercambio de datos de ECU"
      },
      "item_5": {
        "title": "Activos de ECU",
        "description": "Ver y buscar todos los activos de ECU"
      },
      "item_6": {
        "title": "Registros de procesos de ECU",
        "description": "Acceder a los registros de procesos para transparencia y gestión de incidentes"
      }
    },
    "howTo": {
      "description": "Cree cadenas de suministro resilientes mediante notificaciones automáticas de estado y bucles de retroalimentación para las Unidades de Control Electrónico dentro de la red Catena-X.",
      "doc": "¿Desea saber más sobre cómo funciona la mensajería de las Unidades de Control Electrónico (ECU)?"
    },
    "filters": {
      "senderBpn": "BPN del remitente",
      "receiverBpn": "BPN del destinatario",
      "catenaXId": "ID Catena-X",
      "ecuId": "ID ECU",
      "catenaXSiteId": "ID del sitio Catena-X"
    },
    "table": {
      "conversationName": "Nombre de la conversación",
      "senderBpn": "BPN del remitente",
      "receiverBpn": "BPN del destinatario",
      "sentOn": "Enviado el",
      "receivedOn": "Recibido el"
    },
    "errors": {
      "fetchNotifications": "Error al obtener las notificaciones ECU"
    },
    "stats": {
      "total": "Total",
      "messagesPerCountry": "Mensajes por país",
      "sentMessages": "Mensajes enviados",
      "receivedMessages": "Mensajes recibidos",
      "technicalSpecifications": "Especificaciones técnicas",
      "connector": "Conector",
      "connectors": "Conectores",
      "policies": "Políticas",
      "viewAllConnectors": "Ver todos los conectores",
      "viewAllPolicies": "Ver todas las políticas"
    }
  },
  "qualityAlert": {
    "sendSuccess": "¡Enviado correctamente!",
    "sendAlert": "Enviar alerta de calidad",
    "sendInvestigation": "Enviar investigación de calidad",
    "updateSuccess": "¡Actualizado con éxito!",
    "updateAlert": "Alerta de calidad de actualización",
    "updateInvestigation": "Actualizar investigación de calidad",
    "acceptConfirmTitle": "Aceptar alerta de calidad",
    "acceptConfirmDesc": "Al hacer clic en Sí, acepta esta alerta de calidad y acepta tomar las medidas adecuadas.",
    "rejectConfirmTitle": "Rechazar alerta de calidad",
    "rejectConfirmDesc": "Al hacer clic en Sí, rechazas esta alerta de calidad. "
  },
  "traceability": {
    "title": "Trazabilidad",
    "description": "Bienvenido a la aplicación de trazabilidad de extremo a extremo fácil de usar para el intercambio de datos Catena-X",
    "createQualityAlertOrInvestigation": "Crear alerta de calidad o investigación",
    "learnMore": "Más información sobre Trazabilidad",
    "recentIndustryCoreNotifications": "Notificaciones principales recientes de la industria",
    "recentTraceabilityNotifications": "Notificaciones de trazabilidad recientes",
    "tabs": {
      "inbound": "Entrante",
      "outbound": "saliente",
      "published": "Publicado",
      "consumed": "Consumado"
    },
    "howTo": {
      "description": "Descubra el catálogo de ofertas de datos de otras empresas miembros de Catena-X. ",
      "doc": "¿Quiere saber más sobre el trabajo de consumo y negociación de ofertas de datos?"
    },
    "tiles": {
      "createOffer": {
        "title": "Crear oferta de trazabilidad",
        "description": "Cree y comparta datos de trazabilidad con los participantes de la red Catena-X"
      },
      "discoverData": {
        "title": "Descubra los datos de trazabilidad",
        "description": "Busque y negocie datos de trazabilidad dentro de la red Catena-X"
      },
      "notifications": {
        "title": "Notificaciones de trazabilidad",
        "description": "Acceso rápido a notificaciones de calidad, como alertas de calidad e investigaciones de calidad."
      },
      "industryCoreNotifications": {
        "title": "Notificaciones principales de la industria",
        "description": "Vea notificaciones de eventos de gemelos digitales, como actualizaciones de submodelos, eventos de comentarios y más"
      },
      "contractAgreements": {
        "title": "Acuerdos contractuales",
        "description": "Ver todos los acuerdos contractuales proporcionados y consumidos"
      },
      "exchangeHistory": {
        "title": "Historial de intercambio",
        "description": "Obtenga transparencia sobre su historial de intercambio de datos de trazabilidad en la red Catena_X y sus socios",
        "uploadHistory": "Cargar historial",
        "downloadHistory": "Historial de descargas"
      },
      "blockNotifications": {
        "title": "Bloquear notificaciones",
        "description": "Informe fácil y rápidamente defectos y envíe notificaciones en bloque a los socios para las piezas afectadas."
      }
    }
  },
  "useCases": {
    "ecu": {
      "title": "ECU",
      "description": "Mensajería ECU"
    },
    "ecuTest": {
      "title": "ECU-TEST",
      "description": "Mensajería ECU sin restricción a socios comerciales"
    },
    "co2": {
      "title": "Sostenibilidad y huella de CO2",
      "description": "Sostenibilidad y huella de CO2"
    },
    "dcm": {
      "title": "Gestión de datos de socios comerciales",
      "description": "Gestión de demanda y capacidad - menos cuellos de botella, más seguridad"
    },
    "ce": {
      "title": "Economía circular",
      "description": "Economía circular - máximo aprovechamiento de los recursos"
    },
    "companyCertificates": {
      "title": "Certificados de empresa",
      "description": "Optimiza el proceso de gestión e intercambio de certificados de empresa, reduciendo la carga de mantener múltiples certificados para diferentes clientes"
    },
    "cyberSecurityKpi": {
      "title": "Métricas de ciberseguridad",
      "description": "Optimiza el proceso de gestión e intercambio de KPI de ciberseguridad, reduciendo la carga de mantener múltiples KPI para diferentes clientes"
    },
    "traceability": {
      "title": "Trazabilidad",
      "description": "La trazabilidad permite seguir piezas y materiales físicos a lo largo de toda la cadena de valor para habilitar casos de uso basados en datos en todos los niveles n-tier sin comprometer la soberanía de los datos"
    },
    "blockingNotifications": {
      "title": "Notificaciones bloqueantes",
      "description": ""
    },
    "batteryPassBmw": {
      "title": "Pasaporte de batería (BMW)",
      "description": "Pasaporte de batería BMW: uso máximo de los recursos en la cadena de suministro de baterías"
    },
    "modularProduction": {
      "title": "Producción modular",
      "description": "Producción modular"
    },
    "qualityManagement": {
      "title": "Gestión de la calidad",
      "description": "Gestión de la calidad"
    },
    "realTimeControl": {
      "title": "Control en tiempo real",
      "description": "Control en tiempo real"
    }
  }
}
